import { render, staticRenderFns } from "./articlePassword.vue?vue&type=template&id=31878753&scoped=true"
import script from "./articlePassword.vue?vue&type=script&lang=js"
export * from "./articlePassword.vue?vue&type=script&lang=js"
import style0 from "./articlePassword.vue?vue&type=style&index=0&id=31878753&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31878753",
  null
  
)

export default component.exports